module.exports = "/src/views/player/help/images/interior.jpg";